import React from 'react'

import HTML from '../assets/html.png'
import CSS from '../assets/css.png'
import GitHub from '../assets/github.png'
import JavaScript from '../assets/javascript.png'
import Node from '../assets/node.png'
import ReactJS from '../assets/react.png'
import Tailwind from '../assets/tailwind.png'
import SASS from '../assets/sass.png'
import Bootstrap from '../assets/Bootstrap.png'
import NextJS from '../assets/NextJS.png'
import Java from '../assets/Java.png'
import Python from '../assets/Python.png'
import Postgre from '../assets/PostgreSQL.jpg'

const Skills = () => {
  return (
    <div name='skills' className='bg-[rgb(255,255,255)] w-full min-h-full py-14 my-16'>
        {/* container */}
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-screen sm:h-fit md:min-h-screen'>
          <div className=''>
            <p className='text-4xl font-bold inline border-b-2 border-[#d4d4d4] cursor-default'>Skills</p>
            <p className='py-4'> These are technologies I've worked with:</p>
          </div>
          <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={HTML} alt="Logo_of_html" />
              <p className='my-4 font-bold'>HTML</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={CSS} alt="Logo_of_css" />
              <p className='my-4 font-bold'>CSS</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={SASS} alt="Logo_of_sass" />
              <p className='my-4 font-bold'>SCSS</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={JavaScript} alt="Logo_of_js" />
              <p className='my-4 font-bold'>JavaScript</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={ReactJS} alt="Logo_of_reactjs" />
              <p className='my-4 font-bold'>ReactJS</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={Node} alt="Logo_of_nodejs" />
              <p className='my-4 font-bold'>NodeJS</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={Tailwind} alt="Logo_of_tailwind" />
              <p className='my-4 font-bold'>Tailwind CSS</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={Bootstrap} alt="Logo_of_bootstrap" />
              <p className='my-4 font-bold'>BootStrap</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={NextJS} alt="Logo_of_nextjs" />
              <p className='my-4 font-bold'>NextJS</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={Java} alt="Logo_of_java" />
              <p className='my-4 font-bold'>Java</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={Python} alt="Logo_of_python" />
              <p className='my-4 font-bold'>Python</p>
            </div>
            <div className='shadow-md shadow-[#040c16] rounded-md hover:scale-105 duration-500 hover:bg-[rgb(236,234,234)]'>
              <img className='w-20 mx-auto mt-3' src={Postgre} alt="Logo_of_postgresql" />
              <p className='my-4 font-bold'>PostgreSQL</p>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Skills